import styles from './Badge.module.sass'

interface Props {
  label?: string
  className?: string
  content?: string
}

const Badge = (props: Props) => {
  const { label = undefined, className = '', content = null } = props

  return label ? (
    <div className={`${styles.root} ${className}`}>{label}</div>
  ) : content ? (
    <div className={`${styles.root} ${className}`} dangerouslySetInnerHTML={{ __html: content }} />
  ) : (
    <></>
  )
}

export default Badge
